import { PlexUserRelationState } from '@all-hands-hq/plex-graphql-schema';
import { Button, createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { selectAllPlexesFilterItem } from '../../../../../models/filters/actions/selectAllPlexesFilterItem';
import { useFiltersState } from '../../../../../models/filters/useFiltersState';
import { ReduxPlex } from '../../../../../models/ReduxPlex';
import { colorPalette, spacings, TextSizesEnum } from '../../../../../theme';
import { PlexTypography } from '../../../../shared/primitives/PlexTypography';
import { PlexesList } from './PlexesList';
import { SubscribePlexButton } from './SubscribePlexButton';

type Props = {
  plexes: ReduxPlex[];
};

export const PlexesSection = React.memo(
  (props: Props): React.ReactElement => {
    const classes = useStyles();
    const { plexes } = props;
    const [, dispatch] = useFiltersState();
    const handleSelectAll = (selected: boolean): void => {
      dispatch(selectAllPlexesFilterItem({ selected, plexPermalinks: new Set(plexes.map((p) => p.permalink)) }));
    };

    return (
      <div className={classes.root}>
        <div className={classes.header}>
          <Button
            className={classes.headerButton}
            onClick={(): void => {
              const selectedItemsCount = plexes.filter((p) => p.selected).length;
              handleSelectAll(selectedItemsCount !== plexes.length);
            }}
            classes={{ label: classes.headerButtonLabel }}
          >
            <PlexTypography className={classes.headerTitle} text={'PLEXES'} size={TextSizesEnum.Normal} />
          </Button>
          <SubscribePlexButton className={classes.addPlexButton} />
        </div>

        <PlexesList
          mode={'team_plexes'}
          title={'Team Plexes'}
          plexes={plexes.filter((p) => p.currentUserRelation.state !== PlexUserRelationState.Subscriber)}
        />
        <PlexesList
          mode={'subscriptions'}
          title={'Subscriptions'}
          plexes={plexes.filter((p) => p.currentUserRelation.state === PlexUserRelationState.Subscriber)}
        />
      </div>
    );
  }
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      height: 32,
      marginTop: spacings.normal,
      marginBottom: spacings.small,
      position: 'relative',
    },
    headerButton: {
      display: 'flex',
      width: '100%',
      height: '100%',
      borderRadius: 0,
    },
    headerButtonLabel: {
      justifyContent: 'flex-start',
    },
    addPlexButton: {
      display: 'flex',
      position: 'absolute',
      right: 0,
    },
    headerTitle: {
      color: colorPalette.dark._800,
      fontWeight: 'bold',
      paddingLeft: spacings.normal,
    },
  })
);
